import React from "react";
import { Button, Form, Input, Typography, Divider } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { authenticate } from "../../services/user.service";
import { useMutation } from "react-query";
import { AlertService } from "../../services/alert.service";
import { useNavigate } from "react-router";

export default function Login() {
  const [formLogin] = Form.useForm();

  const navigate = useNavigate();

  const { Title, Text, Link } = Typography;

  const { mutate: login, isLoading: loginLoading } = useMutation(authenticate, {
    onSuccess: async (response: any) => {
      localStorage.setItem("user", JSON.stringify(response.user));

      if (response?.user?.canAccess?.length === 1) {
        return window.location.replace("/admin/account");
      } else {
        return window.location.replace("/");
      }
    },
  });

  const onFinish = async (values: any) => {
    formLogin
      .validateFields()
      .then((values) => {
        values.email = values.email.trim();
        values.password = values.password.trim();

        login(values);
      })
      .catch(() =>
        AlertService.sendAlert([
          { text: "Campo(s) com preenchimento inválido", type: "error" },
        ])
      );
  };

  return (
    <div style={{ padding: "0 20px" }}>
      <div style={{ textAlign: "center", marginBottom: 30 }}>
        <Title level={2} style={{ marginBottom: 10 }}>
          Bem-vindo de volta!
        </Title>
        <Text type="secondary" style={{ fontSize: 16 }}>
          Insira seus dados para acessar a sua conta
        </Text>
      </div>

      <Form
        onFinish={onFinish}
        form={formLogin}
        layout="vertical"
        size="large"
        requiredMark={false}
      >
        <Form.Item
          name="email"
          label="E-mail"
          style={{ marginBottom: 10 }}
          rules={[
            { required: true, message: "Por favor insira um email válido!" },
            { type: "email", message: "Formato de email inválido" },
          ]}
        >
          <Input
            prefix={<UserOutlined className="site-form-item-icon" />}
            placeholder="seu@email.com"
          />
        </Form.Item>

        <Form.Item
          name="password"
          label="Senha"
          style={{ marginBottom: 10 }}
          rules={[
            {
              required: true,
              message: "Por favor insira sua senha!",
            },
          ]}
        >
          <Input.Password
            prefix={<LockOutlined className="site-form-item-icon" />}
            placeholder="Sua senha"
          />
        </Form.Item>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: 24,
          }}
        >
          <Link onClick={() => navigate("/forgot-password")}>
            Esqueceu sua senha?
          </Link>
        </div>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            block
            loading={loginLoading}
            style={{ height: 45, fontSize: 16 }}
          >
            Entrar
          </Button>
        </Form.Item>

        <Divider plain>Ou</Divider>

        <div style={{ textAlign: "center" }}>
          <Text>Não tem uma conta? </Text>
          <Link
            style={{ fontWeight: "bold" }}
            onClick={() => navigate("/register")}
          >
            Cadastre-se grátis
          </Link>
        </div>
      </Form>
    </div>
  );
}
